import * as React from 'react'
import classNames from 'classnames'

interface IProps {
  type?: 'prev' | 'next'
  className?: string
  clkTeaParams?: string
  buttonStyle?: React.CSSProperties
  onClick?: () => void
  theme?: 'light' | 'gray'
}
const SwiperButton = React.forwardRef<HTMLInputElement, IProps>(
  (
    {
      type = 'prev',
      className = '',
      buttonStyle = {},
      onClick,
      clkTeaParams,
      theme = 'light',
    },
    ref
  ) => {
    return (
      <React.Fragment>
        <span
          ref={ref}
          onClick={() => onClick?.()}
          className={classNames('button-wrapper', className, type)}
          style={buttonStyle}
          data-log-click={clkTeaParams}
        >
          <button
            type={'button'}
            className={`swiper-button swiper-button--${theme}`}
          >
            <i
              className={classNames('DCD_Icon', {
                icon_triangle_right: type === 'next',
                icon_triangle_left: type === 'prev',
              })}
            />
          </button>
        </span>
        <style jsx>
          {`
            .button-wrapper {
              height: 34px;
              width: 34px;
              text-align: center;
              padding: 6px;
            }
            .swiper-button {
              width: 22px;
              height: 22px;
              line-height: 22px;
              border-radius: 4px;
              color: #1f2129;
            }
            .swiper-button--light {
              background: #fff;
            }
            .swiper-button--gray {
              background: #f7f8fc;
            }
            .button-wrapper:not(.swiper-button-disabled) .swiper-button:hover {
              background: #616370;
              color: #f2f4fa;
            }
            .swiper-button-disabled {
              display: inline-block;
            }
            .swiper-button-disabled > .swiper-button {
              cursor: default;
              color: #c9cbd6;
            }
          `}
        </style>
      </React.Fragment>
    )
  }
)

export default SwiperButton
